import { URL_FAILED, WEDDING_FAILED, WEDDING_PASSED } from "../types";

const initialState = {
	couple: {},
	error: false,
	message: "",
	title: "",
	urls: [],
	timezone: [],
	urlmessage: "",
};

//selectors
export const getWedding = (state) => state.wedding;

//reducers
export const weddingReducer = (state = initialState, action) => {
	// console.log("\n<========I am the wedding reducer action ======> \n", action);
	switch (action.type) {
		case "WEDDING_CREATE":
			return {
				...state,
				error: false,
				message: action.message,
				couple: action.payload,
			};
		case "WEDDING_URLS":
			return {
				...state,
				error: false,
				urls: action.payload,
			};
		case "TIMEZONE":
			return {
				...state,
				error: false,
				timezone: action.payload,
			};
		case WEDDING_FAILED:
			return {
				...state,
				error: true,
				message: action.payload,
				title: action.title,
				code: action.code,
			};
		case WEDDING_PASSED:
			return {
				...state,
				error: false,
				message: action.payload || action.message,
				title: action.title,
			};
		case URL_FAILED:
			return {
				...state,
				error: true,
				urlmessage: action.payload,
				title: action.title,
				code: action.code,
			};
		default:
			return {
				...state,
			};
	}
};
